import React, { useEffect, useState } from "react";
import "./_systemPrompt.scss";
import Modal from "react-bootstrap/Modal";
import axios from "axios";
import DashboardSideBar from "./DashboardSideBar";
import Actiondropdown from "./ActionDropDown";
import { toast } from "react-toastify";
import { Spin } from "antd";

const SystemPrompt = () => {
  const Apiurl = process.env.REACT_APP_API_KEY;
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const [smShow, setSmShow] = useState(false);
  const [query, setQuery] = useState("");
  const [model, setModel] = useState("GPT 4");
  const [temperature, setTemperature] = useState("0.5");
  const [maxtoken, setMaxtoken] = useState("250");
  const [data, setData] = useState("");
  const [loading, setLoading] = useState(true);

  const handleResponseChange = (event) => {
    setData(event.target.value);
  };

  const handleTemperatureChange = (event) => {
    setTemperature(event.target.value);
  };

  const handleMaxTokenChange = (event) => {
    setMaxtoken(event.target.value);
  };

  const getData = () => {
    const logintoken = localStorage.getItem("authToken");
    setLoading(true);
    axios
      .get(`${Apiurl}/admin/get_config `, {
        headers: {
          "x-access-token": logintoken,
        },
      })
      .then((res) => {
        setModel(res.data.model);
        setMaxtoken(res.data.max_tokens);
        setTemperature(res.data.temperature);
        setData(res.data.system_prompt);
        console.log(res.data);
        setLoading(false);
      })
      .catch((err) => {
        console.error(err);
        setLoading(false); // Handle errors
      });
  };

  const handleUpdate = () => {
    const logintoken = localStorage.getItem("authToken");
    const requestData = {
      model: model,
      temperature: temperature,
      max_tokens: maxtoken,
      system_prompt: data,
    };

    axios
      .post(`${Apiurl}/admin/update_config`, requestData, {
        headers: {
          "x-access-token": logintoken,
        },
      })
      .then((response) => {
        toast.success("Updated Successfully!", { toastId: "updated" });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  const handleReset = () => {
    const logintoken = localStorage.getItem("authToken");
    axios
      .post(
        `${Apiurl}/admin/reset_config`,
        {},
        {
          headers: {
            "x-access-token": logintoken,
          },
        }
      )
      .then((response) => {
        getData();
        // setSmShow(true);
        toast.success("Reset Successfully!", { toastId: "reset" });
        setShow(false);
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  };

  useEffect(() => {
    getData();
  }, []);
  // set as default
  const handleSetDefault = async () => {
    try {
      // Retrieve the token from localStorage
      const logintoken = localStorage.getItem("authToken");
      console.log(logintoken);

      if (!logintoken) {
        toast.error("User is not logged in. Please log in to continue.");
        return;
      }

      // Make the POST request
      const response = await axios.post(
        `${Apiurl}/admin/set_default_config`,
        {
          system_prompt: data,
          model: model,
          temperature: temperature,
          max_tokens: maxtoken,
        },
        {
          headers: {
            "Content-Type": "application/json",
            // Authorization: `Bearer ${logintoken}`,
            "x-access-token": logintoken,
          },
        }
      );

      // Handle the response when true
      toast.success(" set as Default successfully!");
    } catch (error) {
      toast.error("An error occurred while set as default.");
    }
  };

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}
      >
        <Spin size="large" />
      </div>
    ); // Render loading state
  }
  return (
    <DashboardSideBar>
      <div className="w-100">
        <div className="d-flex">
          <div className="dashboard w-100">
            <div className="main">
              <div className="text-center mt-5 mb-3">
                <h1>Model</h1>
                <p className="opacity-50">
                  Section allows you to configure the model for the assistant.
                </p>
              </div>
              <div className="divider">
                <div className="leftsection">
                  <div className="title">
                    <p className="headerQuery">System Prompt</p>
                    <div className="add_databases_btn">
                      <button onClick={handleSetDefault}>Set as default</button>
                    </div>
                  </div>

                  <div className="contentMain mt-2">
                    <div className="content">
                      <textarea
                        className="response"
                        type="text"
                        value={data}
                        onChange={handleResponseChange}
                        placeholder="Response of Query"
                        rows={18}
                      />
                    </div>
                  </div>
                </div>
                <hr />
                <div className="rightsection">
                  <div className="rightsection-Mainn">
                    <div className="rightsection-Main">
                      <div className="right-Top">
                        <p className="modelp">Model</p>
                        <Actiondropdown model={model} setModel={setModel} />
                      </div>
                      <div className="right-Mid">
                        <div className="mid-main">
                          <p className="modelp">Temperature</p>
                          <p className="temp">{temperature}</p>
                        </div>
                        <input
                          type="range"
                          min={0.1}
                          max={1}
                          step={0.1}
                          value={temperature}
                          onChange={handleTemperatureChange}
                        />
                      </div>
                      <div className="right-low d-none">
                        <p className="text-start mb-2 modelp">Max Token</p>
                        <input
                          className="token"
                          type="number"
                          min={250}
                          value={maxtoken}
                          placeholder="250"
                          onChange={handleMaxTokenChange}
                        />
                      </div>

                      <div className="add_databases_btn">
                        <button onClick={handleUpdate}>Update</button>
                      </div>
                    </div>
                    {/* add on more extra button that is for now reset to current  */}
                    <div className="">
                      <div className="add_databases_btn mt-2">
                        <button onClick={handleShow}>Reset to Default</button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <Modal
              className="model-Main"
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={show}
              onHide={handleClose}
            >
              <Modal.Body className="model-Body">
                <p className="areyouSure">
                  Are you sure you want to reset it to the default?
                </p>
                <div className="model-bdy">
                  <button className="yes" onClick={handleReset}>
                    Yes
                  </button>
                  <button className="no" onClick={handleClose}>
                    No
                  </button>
                </div>
              </Modal.Body>
            </Modal>
          </div>
        </div>
      </div>
    </DashboardSideBar>
  );
};

export default SystemPrompt;
